import { OnInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import * as toastr from "toastr";
import * as moment from 'moment';

import { State } from '@shared/models/state.interface';

import { VisitasService } from '../../services/visitas.service';

@Component({
    selector: 'app-edicao',
    templateUrl: './edicao.component.html',
    styleUrls: ['./edicao.component.css']
  })
  export class EdicaoComponent implements OnInit {

    myForm = {
        dataVisita: "",
        dataAgendada: "",
        setor: "",
        cnpj: "",
        razaoSocial: "",
        cep: "",
        uf: "",
        cidade: "",
        bairro: "",
        logradouro: "",
        statusVisita: "",
        houveProposta: false,
        qtdVendida: "",
        notasVisita: "",
        alerta: "",
        dias: "",
        formaVisita: "",

    }

    filterGetVisita = {
        idCliente: "",
        idSetor: "",
        idFilial: "",
        dataPrev: ""
    }

    selectedDia: string;
    selectedStatus;
    selectedSetor: string;
    selectedState: string;
    selectedFormaVisita;

    lsDias: any[] = [];
    lsStatusVisita: any[] = [];
    lsSetores: any[] = [];
    lsStates: State[];
    lsVisita: any;
    lsClientes: any[] = [];
    lsAlertas: any[] = [];
    lstAlertasExibicao: any[] = [];
    lsFormasVisitas: any[] = [];
    OutrasInfo: string;

    telaPlanejamento: boolean = false;
    telaEdicao: boolean = false;
    telaDetalhe: boolean = false;
    showAlertsInputs: boolean = false;
    showMessageAlert: boolean = false;

    formGroup: FormGroup;

    cnpjPattern = /^([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})$/i

    userLogado;

    today;

    reagendamento: boolean = false;
    dataReagendamento;
    minReagendamento;
    maxReagendamento;

    statusUltimaVisita: boolean = false;

    desableAllInputs: boolean = false;
    salvarButtomDisabled: boolean = false;
    dayGreaterOrEqualToCurrent: boolean = false;

    daysLimitRescheduling = 1;
    dateLimitStartRescheduling:string;
    dateLimitEndRescheduling:string;
    resultVisitDisabled = false;

    desableDatesVisitasSemPlanejamento: boolean = false;
    limitDay: boolean = false;
    statusCarregadoVisitaProgramada: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public formBuilder: FormBuilder,
        private visitService: VisitasService,
        private _location: Location){
            this.formGroup = this.formBuilder.group({
                cnpj: ['', [Validators.required, Validators.pattern(this.cnpjPattern)]]
            });
        }


    ngOnInit() {
        //volta ao topo
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });

        this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

        this.today = new Date().toJSON().split('T')[0];

        this.setCurrentAction();
        this.fillDays();
        this.getStatus();
        this.getSetores();
        this.getStates();
        this.calculaReagendamento();
    }

    verificaPlanejamento() {
        this.lsVisita.idStatusVisita == 18 ? this.desableDatesVisitasSemPlanejamento = false : this.desableDatesVisitasSemPlanejamento = true;
    }

    desableAll(){

        console.log('desableAll');
        console.log(this.lsVisita.idStatusVisita);
        console.log(this.telaEdicao);

        //Por solicitação da Miriam liberar edição para dia 30/04/2021 chamado #2221 permitir edição do dia 04 ao dia 07/05/2021
        let today = moment().format('DD/MM/YYYY');
        console.log(today, ' today', typeof(today));
        if(this.myForm.dataAgendada === '30/04/2021' && (today == '04/05/2021' || today == '05/05/2021' || today == '06/05/2021' || today == '07/05/2021')){
            //Codigo para habilitar edição de histórico de visitas
            let resultBefore = false;
            let resultAfter = false;
            this.limitDay = false;
            this.desableAllInputs = false;
            this.resultVisitDisabled = false;

        } else if(this.telaEdicao && this.lsVisita.idStatusVisita == 18){ //Codigo original
            
            let dataAgendada = moment(this.lsVisita.dataPrev, '"DD/MM/YYYY"');
            dataAgendada.set({'hour': 6, 'minute': 30});
            let tomorrow  = moment(dataAgendada).add(this.daysLimitRescheduling,'days');
            let tomorrowHour = moment(tomorrow).set({'hour': 6, 'minute': 30});
            let resultBefore = moment().isBefore(dataAgendada);
            let resultAfter = moment().isAfter(tomorrowHour);
            console.log(resultAfter, ' resultAfter');
            this.dateLimitStartRescheduling = dataAgendada.format('DD/MM/YYYY');
            this.dateLimitEndRescheduling =  tomorrow.format('DD/MM/YYYY');
            console.log('dataAgendada1: ', dataAgendada, 'resultBefore: ', resultBefore, 'resultAfter: ', resultAfter)

            // if(this.telaEdicao && (resultBefore || resultAfter)){
            //     this.desableAllInputs = true;
            //     this.limitDay = true;
            // }

            let diaAtual = moment();
            diaAtual.set({'hour': 0, 'minute': 0, second: 0});

            if(this.telaEdicao && (dataAgendada < diaAtual)){
                this.desableAllInputs = true;
                this.limitDay = true;
                this.dayGreaterOrEqualToCurrent = true;
            }
            
        } else if (this.telaEdicao) { //demais visitas
            let dataAgendada = moment(this.lsVisita.dataPrev, '"DD/MM/YYYY"');
            dataAgendada.set({'hour': 6, 'minute': 30});
            let tomorrow  = moment(dataAgendada).add(this.daysLimitRescheduling,'days');
            let tomorrowHour = moment(tomorrow).set({'hour': 6, 'minute': 30});
            let resultBefore = moment().isBefore(dataAgendada);
            let resultAfter = moment().isAfter(tomorrowHour);
            console.log(resultAfter, ' resultAfter');
            this.dateLimitStartRescheduling = dataAgendada.format('DD/MM/YYYY');
            this.dateLimitEndRescheduling =  tomorrow.format('DD/MM/YYYY');
            console.log('dataAgendada1: ', dataAgendada,  typeof(dataAgendada) , 'resultBefore: ', resultBefore, 'resultAfter: ', resultAfter)
            
            // if(this.telaEdicao && (resultBefore || resultAfter)){
            //     this.desableAllInputs = true;
            //     this.limitDay = true;
            //     this.desableAllInputs = false;
            //     this.salvarButtomDisabled = true;
            // }

            console.log("moment", moment());
            console.log("diaAgendado", dataAgendada);
            let diaAnterior = moment().isBefore(dataAgendada);
            console.log("diaAnterior", diaAnterior);
            let diaAtual = moment();
            diaAtual.set({'hour': 0, 'minute': 0, second: 0});
            console.log("diaAtual", diaAtual);
            console.log("dataAgendada >= diaAtual", dataAgendada >= diaAtual);

            if(this.telaEdicao && (dataAgendada < diaAtual)){
                this.desableAllInputs = true;
                this.limitDay = true;
                this.desableAllInputs = false;
                this.salvarButtomDisabled = true;
                this.dayGreaterOrEqualToCurrent = true;
            }
            
            
        }
        else { //demais visitas
            this.desableAllInputs = true;
        }
        console.log(this.limitDay, ' data limite');
        console.log(this.lsVisita.idStatusVisita, 'idStatusVisita', this.telaEdicao, 'telaEdição');

    }

    calculaReagendamento() {
        let min = moment().add(1, 'day');
        let max = moment().add(31, 'days').calendar();

        this.minReagendamento = moment(min).format("YYYY-MM-DD");
        this.maxReagendamento = moment(max).format("YYYY-MM-DD");
    }

    verificaHabilitaSetor(){
        if(this.telaPlanejamento && this.userLogado.perfil==2){
            return false;
        } else if(this.telaEdicao && this.userLogado.perfil==2 ){
            return false;
        }else{
            return true;
        }
    }

    fillDays(){
        let i = 1;
        while(i < 30){
            i++;
            this.lsDias.push(i);
        }
    }

    fillInputs(){
        console.log('lsss', this.lsVisita)
        this.selectedSetor = this.userLogado.idSetor;
        this.myForm.setor = this.selectedSetor;
        this.myForm.cnpj = this.lsVisita.cnpj;
        this.formGroup.controls.cnpj.setValue(this.myForm.cnpj.toString());
        this.myForm.razaoSocial = this.lsVisita.razaoSocial;
        this.myForm.cep = this.lsVisita.cep.toString();
        this.myForm.cidade = this.lsVisita.cidade;
        this.myForm.bairro = this.lsVisita.bairro;
        this.myForm.uf = this.lsVisita.uf;
        this.myForm.logradouro = this.lsVisita.logradouro;
        this.myForm.notasVisita = this.lsVisita.dsNotaVisita != null || this.lsVisita.dsNotaVisita != "" ? this.lsVisita.dsNotaVisita : '';
        this.myForm.formaVisita = this.lsVisita.formaVisita

        let dt = this.lsVisita.dataPrev.toString(); // em formato MM/DD/YYYY HH:mm:ss
        let m = moment(dt, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        this.myForm.dataAgendada = m;
        this.selectedStatus = "Venda";

        if(this.lsVisita.qtdVendida > 0){
            this.selectedStatus = 15;
            this.resultVisitDisabled = true;
        }else{
            this.selectedStatus = this.lsVisita.idStatusVisita;
        }

        this.myForm.statusVisita = this.selectedStatus;
        this.myForm.qtdVendida = this.lsVisita.qtdVendida;
        if(this.lsVisita.dataVisita != "" || this.lsVisita.dataVisita != null) {
            this.myForm.dataVisita = moment(this.lsVisita.dataVisita, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD')
        }

        if(this.lsVisita.dataVisita == "" || this.lsVisita.dataVisita == null){
            this.myForm.dataVisita = moment(this.lsVisita.dataPrev, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD");
        }

        this.lsVisita.idStatusVisita == 10 ? this.statusCarregadoVisitaProgramada = false : '';

        if(this.lsVisita.inProposta != null || this.lsVisita.inProposta != "") {
            this.lsVisita.inProposta == 'S' ? this.myForm.houveProposta = true : this.myForm.houveProposta = false;
        }
    }

    fillInputsClientePorCnpj(){
        //this.formGroup.controls.cnpj.setValue(this.lsClientes[0].cnpj.toString());
        this.myForm.razaoSocial = this.lsClientes[0].razaoSocial;
        this.myForm.cep = this.lsClientes[0].cep.toString();
        this.myForm.bairro = this.lsClientes[0].bairro;
        this.myForm.logradouro = this.lsClientes[0].logradouro;
        this.myForm.uf = this.lsClientes[0].uf;
        this.myForm.cidade = this.lsClientes[0].cidade;
    }

    private setCurrentAction() {

        if(this.route.snapshot.url[0].path != "planejamento"){
            if(this.route.snapshot.url[4].path === 'edit'){
                this.formGroup.controls["cnpj"].disable();
                this.telaEdicao = true;
            }else{
                this.formGroup.controls["cnpj"].disable();
                this.telaDetalhe = true;
            }

            this.filterGetVisita.idCliente = this.route.snapshot.url[0].path;
            this.filterGetVisita.idSetor = this.route.snapshot.url[1].path;
            this.filterGetVisita.idFilial = this.route.snapshot.url[2].path;
            this.filterGetVisita.dataPrev = this.route.snapshot.url[3].path;
            this.getVisita();
      }else {
          this.telaPlanejamento = true;
          this.myForm.dataVisita = moment().format("YYYY-MM-DD");
      }

    }

    getOutrasInfo(idCliente){
        this.visitService.getClienteById(idCliente, false).subscribe(
            resp => {
                let respFormatada = resp.join(', ');
                this.OutrasInfo = respFormatada
            },
            error => console.log(error)
        )
    }

    getAlertasByCliente(idCliente, data){
        this.visitService.getAlertasByCliente(idCliente, data).subscribe(
            resp => {
                this.lsAlertas = resp,
                resp.forEach(e => {
                    this.lstAlertasExibicao.push(e)
                });
            },
            error => console.log(error)
        )
    }

    getVisita(){
        this.visitService.getVisita(this.filterGetVisita.idCliente, this.filterGetVisita.idSetor, this.filterGetVisita.idFilial, this.filterGetVisita.dataPrev).subscribe(
            resp=>{
                console.log('Entrou getVisita');

                this.lsVisita = resp
                this.fillInputs();
                this.desableAll();
                this.verificaPlanejamento();
                this.getOutrasInfo(this.filterGetVisita.idCliente);

                if(this.telaEdicao){
                    this.lsVisita.idStatusVisita == 18 ? this.statusUltimaVisita = true : ''; //se status agendado desabilita select de status
                    let data = "";
                    if(this.lsVisita.dataVisita == null || this.lsVisita.dataVisita == "") {
                        let dt = this.lsVisita.dataPrev.toString(); // em formato MM/DD/YYYY HH:mm:ss
                        data = moment(dt, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD');
                    } else {
                        data = moment(this.lsVisita.dataVisita, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD');
                    }
                    this.getAlertasByCliente(this.lsVisita.idCliente, data);
                }
            },
            error=>console.log(error)
        )
    }

    getStates(){
        this.visitService.getStates(this.userLogado.idSetor).subscribe(data => this.lsStates = data,
          error => console.log(error),
          () => console.log('States Loaded'));
      }

    getByCNPJ(){
        if(this.formGroup.valid) {
            let cnpj = this.formGroup.value.cnpj.toString();
            let cnpjCliente = cnpj.replace(/[^a-zA-Z0-9]/g,'');

            this.visitService.getClienteCnpj(cnpjCliente).subscribe(
                resp => {
                    if( resp.length > 0) {
                        this.lsClientes = resp
                        this.fillInputsClientePorCnpj();

                        let data = "";
                        if(this.lsVisita.dataVisita == null || this.lsVisita.dataVisita == "") {
                            let dt = this.lsVisita.dataPrev.toString(); // em formato MM/DD/YYYY HH:mm:ss
                            data = moment(dt, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD');
                        } else {
                            data = moment(this.lsVisita.dataVisita, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD');
                        }

                        this.getAlertasByCliente(resp[0].id, data);
                    } else {
                        this.actionsForError("Nenhum dado foi encontrado para esse CNPJ");
                    }

                },
                error => console.log(error)
            )
        }else{
            this.actionsForError("Informe um CNPJ Válido");
        }
    }

    filterStatus(e){
        /*
        const today = moment().unix()+23400;
        const dataAgendadaSeconds = moment(this.myForm.dataAgendada, 'DD/MM/YYYY').startOf('day').unix();

        if(dataAgendadaSeconds < today || dataAgendadaSeconds> today + 86400){
            toastr.error('data errada')
        }
        */
       console.log('this.selectedStatus: ', this.selectedStatus);
        if(this.selectedStatus == '10'){
            this.reagendamento = true;
            this.salvarButtomDisabled = true;
        }

        //this.myFilter.status = this.selectedStatus.toString();
    }

    getStatus(){
        this.visitService.getStatusVisita().subscribe(
            data => {
                this.lsStatusVisita = data
                let filtered = data;
                this.lsStatusVisita = filtered.filter(e=>e.id!=11).filter(e=>e.id!=12).filter(e=>e.id!=-1).filter(e=>e.id!=17);
                // this.lsStatusVisita = filtered.filter(e=>e.id!=11).filter(e=>e.id!=12).filter(e=>e.id!=-1).filter(e=>e.id!=18).filter(e=>e.id!=17);
            },
            error => console.log(error),
            () => console.log('Status Visita Loaded'));
    }

    getSetores(){
        this.visitService.getSetores().subscribe(data => this.lsSetores = data,
            error => console.log(error),
            () => console.log('Setores Loaded'));
    }

    Alertar(){
        this.showAlertsInputs = true;
        //!this.formGroup.valid ? this.actionsForError("Informe os dados acima"): '';
    }

    adicionaAlerta(){
        this.showMessageAlert = true;

        if(this.telaPlanejamento && this.myForm.dataVisita == ""){
            this.actionsForError("Informe a data da visita");
            return;
        }

        let obj = {
            idCliente: this.telaEdicao ? this.lsVisita.idCliente : this.lsClientes[0].id,
            idSetor: this.telaEdicao ? this.lsVisita.idSetor : this.userLogado.idSetor,
            idFilial: this.telaEdicao ? this.lsVisita.idFilial : 1,
            dataPrev: this.telaEdicao ? this.lsVisita.dataPrev : this.myForm.dataVisita,
            qtdDias:0.0,
            dsAlerta: this.myForm.alerta,
            salvar: true,
            color: 'white'

        }
        if(this.telaPlanejamento){
            let dataPrev = moment(obj.dataPrev).format("YYYY-MM-DD");
            obj.dataPrev = dataPrev;
        }else if (this.telaEdicao) {
            let dataPrev = moment(obj.dataPrev).format("YYYY-MM-DD HH:mm:ss");
            obj.dataPrev = dataPrev;
        }

        this.lstAlertasExibicao.push(obj)
    }

    removeAlerta(index){
        this.lstAlertasExibicao.splice(index, 1);
    }

    checkAlerta(index, item){

        let filtro = {
            IdAlerta: item.idAlerta,
            IdCli: item.idCliente,
            QtdDias: item.qtdDias,
            DsAlerta: item.dsAlerta,
        }

        this.lstAlertasExibicao[index].color = "#f5f5f5";
        if(item["idAlerta"] != undefined) {
            this.visitService.excluirAlerta(filtro).subscribe(
                resp => this.actionsForSuccess("Alerta alterado com sucesso"),
                error => this.actionsForError("Falha ao alterar alerta")
            );
        }else {
            this.actionsForError("Não é possivel alterar um alerta que não foi cadastrado");
        }
    }

    Salvar(){
        this.myForm.cnpj = this.formGroup.value.cnpj;
        this.myForm.dias = this.selectedDia;
        this.myForm.statusVisita =  this.selectedStatus;
        this.myForm.setor = this.selectedSetor;
        this.myForm.uf = this.selectedState;

        if(this.lsVisita && this.lsVisita.idStatusVisita == 17){
            return this.actionsForError("Só é permitido lançar status de visita transmitida!");
        }

        if(!this.formGroup.valid && this.telaPlanejamento){
            return this.actionsForError("Informe um CNPJ válido");
        }

        if(this.telaEdicao){

            if(this.myForm.dataVisita == "" || this.myForm.dataVisita == undefined){
                return this.actionsForError("Informe a data visita")
            }

            this.visitService.editVisita(this.filterEditVisita()).subscribe(
                resp => {
                    this.actionsForSuccess("Visita editada com sucesso");
                    this.SalvarAlertas();
                    this.router.navigate(['/visitas/home']);
                },
                error => {
                    this.actionsForError("Desculpe, tivemos um problema na hora de salvar seus dados, tente novamente mais tarde ou entre em contato com o administrador do sistema.")
                }
            )
        } else if(this.telaPlanejamento){
            let filtro = this.filterSalvarVisitaSemPlanejamento();
            let today = moment(new Date);
            let dt_visita = moment(filtro.DtRealVisita);
            if(filtro.DtRealVisita != undefined || filtro.DtRealVisita != ""){
                if(dt_visita.isAfter(today)){
                    this.actionsForError("A data da visita não pode ser uma data futura");
                } else {
                    this.visitService.salvarVisitaSemPlanejamento(filtro).subscribe(
                        resp => {
                            this.actionsForSuccess("Visita inserida com sucesso!");
                            this.SalvarAlertas();
                        },
                         error => {
                            error=="" ? this.actionsForError("Falha ao inserir!") : this.actionsForError(error)
                        }
                    )
                }
            } else {
                this.visitService.salvarVisitaSemPlanejamento(filtro).subscribe(
                    resp => {
                        this.actionsForSuccess("Visita inserida com sucesso!");
                        this.SalvarAlertas();
                    },
                     error => {
                        error=="" ? this.actionsForError("Falha ao inserir!") : this.actionsForError(error)
                    }
                )
            }
        }

        //salvar visita agendada caso seja um reagendamento
       this.reagendamento ? this.salvarReagendamento() : '';
    }

    salvarReagendamento(){

        if(this.statusCarregadoVisitaProgramada) {
            if(this.lsVisita.dataVisita == ""){
                this.myForm.dataVisita = this.dataReagendamento;
            }

            let data = [];

            let date_ = moment(new Date()).format("YYYY-MM-DD");
            let today = date_;

            let formaVisitaId = 0;
            if(this.selectedFormaVisita != undefined) {
                formaVisitaId = this.selectedFormaVisita.formaVisitaId;
            }

            data.push({
                IdFilialEmpr: 1,
                IdCli: this.telaPlanejamento ? this.lsClientes[0].id : this.lsVisita.idCliente,
                DtPrevVisita: this.dataReagendamento,
                IdStatusVisitaCli: this.selectedStatus,
                DtIncl: today,
                InVisitaPrev: "S",
                IdSetorComc: this.userLogado.idSetor,
                IdVnd: this.telaPlanejamento ? this.userLogado.id : this.lsVisita.idVendedor
            });

            let params = {
                visitas: []
            };
            params.visitas = data;

            this.visitService.saveVisitaReagendamento(params).subscribe(
                resp => this.actionsForSuccess("Reagendamento feito com sucesso"),
                error => {
                    this.actionsForError("Falha ao reagendar: " + error.toString())
                    console.log(error)
                }
            );
        }
    }

    SalvarAlertas(){
        let data = moment(new Date()).format("YYYY-MM-DD");
        let today = data;

        this.lstAlertasExibicao.forEach((e, i) => {

            if(e.salvar == true){
                let filtro = {
                    IdCli: e.idCliente,
                    QtdDias: e.qtdDias,
                    DsAlerta: e.dsAlerta,
                }

                this.visitService.salvarAlerta(filtro).subscribe(
                    resp=> this.actionsForSuccess("Alerta inserido com sucesso!"),
                    error => this.actionsForError("Erro ao inserir alertas!")
                )
            }

        })
    }

    filterEditVisita(){
        let data = new Date();

        let formaVisitaId = 0;
        if(this.selectedFormaVisita != undefined) {
            formaVisitaId = this.selectedFormaVisita.formaVisitaId;
        }

        let filterEdit = {
            IdFilialEmpr: this.lsVisita.idFilial,
            IdSetorComc: this.lsVisita.idSetor,
            IdCli: this.lsVisita.idCliente,
            DtPrevVisita: this.lsVisita.dataPrev,
            IdVnd: this.lsVisita.idVendedor,
            DtRealVisita: this.myForm.dataVisita,
            IdStatusVisitaCli: parseInt(this.selectedStatus),
            DtIncl: `${data.getFullYear()}-${data.getMonth()+1}-${data.getDate()}`,
            InVisitaPrev: this.lsVisita.visitaPrevista,
            InProposta: this.myForm.houveProposta ? 'S': 'N',
            QtVenda: this.myForm.qtdVendida,
            DsNotaVisita: this.myForm.notasVisita,
            inOrder: this.lsVisita.inOrder,
            IdFormaVisita: formaVisitaId
        }

        let dataPrev = moment(filterEdit.DtPrevVisita, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
        let dataVisita = moment(filterEdit.DtRealVisita, 'YYYY-MM-DD').format("YYYY-MM-DD HH:mm:ss");

        filterEdit.DtPrevVisita = dataPrev;
        filterEdit.DtRealVisita != null ? filterEdit.DtRealVisita = dataVisita: '';

        return filterEdit;
    }

    filterSalvarVisitaSemPlanejamento(){
        let data = new Date();
        let today = moment(new Date()).format("YYYY-MM-DD");

        let formaVisitaId = 0;
        this.selectedFormaVisita != undefined ? formaVisitaId = this.selectedFormaVisita.formaVisitaId : null;

        let filterSalvar = {
            IdFilialEmpr: 1,
            IdSetorComc: this.userLogado.idSetor,
            IdCli: this.lsClientes[0].id,
            DtPrevVisita: today,
            IdVnd: this.userLogado.id,
            DtRealVisita: today,
            IdStatusVisitaCli: parseInt(this.selectedStatus),
            DtIncl: `${data.getFullYear()}-${data.getMonth()+1}-${data.getDate()}`,
            InVisitaPrev: 'N',
            InProposta: this.myForm.houveProposta ? 'S': 'N',
            QtVenda: this.myForm.qtdVendida,
            DsNotaVisita: this.myForm.notasVisita,
            IdFormaVisita: formaVisitaId
        }
        formaVisitaId == 0 ? delete filterSalvar.IdFormaVisita : ''; //se não selecionar forma visita tira do filter
        return filterSalvar;
    }

    private actionsForSuccess(message){
        toastr.success(message);
    }

    private actionsForError(message){
        toastr.error(message);
    }

    cancel(){
        this._location.back();
    }

    selectDateRescheduling(date){
        const dayOfWeek = moment(date).day()

        if(dayOfWeek == 0 || dayOfWeek == 6){
            this.dataReagendamento = "";
            toastr.error("O Reagendamento não pode ser num fim de semana");
        }else{
            this.salvarButtomDisabled = false;
        }

    }

    getFormasVisitas() {
        this.visitService.getFormasVisitasAtivas().subscribe(
            resp => {
            this.lsFormasVisitas = resp;
            },
            error => console.log(error)
        )
    }

  }
